/*
 * @Description: 发起项目
 * @Date: 2025-03-03 11:38:40
 */
import { route } from './src/router';

const name = 'project-initiate';
export { name, route };
